interface InputProps {
  label?: string;
  name: string;
  required?: boolean;
  value: string;
  disabled?: boolean;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  clasName?: string;
}

export function TextArea({
  label,
  name,
  value,
  required,
  disabled,
  onChange,
  clasName,
}: InputProps) {
  return (
    <div className={`flex flex-col text-grey ${clasName}`}>
      <label className="3xl:text-md text-sm font-thin">{label}</label>
      <textarea
        name={name}
        value={value}
        required={required}
        disabled={disabled}
        onChange={onChange}
        className={`bg-white shadow-lg border-light-blue border-2 rounded-md max-h-[180px] p-2 mt-1 min-h-[100px]`}
      />
    </div>
  );
}
